export const BRANDS_MOCK = [
  {
    name: 'NARS',
    page: {
      path: '/brands/nars',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Dr Dennis Gross',
    page: {
      path: '/brands/dr-dennis-gross',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Aesop',
    page: {
      path: '/brands/aesop',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: "A'kin",
    page: {
      path: '/brands/a-kin',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Alpecin',
    page: {
      path: '/brands/alpecin',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Alpha H',
    page: {
      path: '/brands/alpha-h',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'American Crew',
    page: {
      path: '/brands/american-crew',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Anthony for Men',
    page: {
      path: '/brands/anthony-for-men',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Aramis',
    page: {
      path: '/brands/aramis',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Ardell Lashes',
    page: {
      path: '/brands/ardell-lashes',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Aromatherapy Associates',
    page: {
      path: '/brands/aromatherapy-associates',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Australian Bodycare',
    page: {
      path: '/brands/australian-bodycare',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Aveda Haircare',
    page: {
      path: '/brands/aveda-haircare',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Avène',
    page: {
      path: '/brands/avene',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'BaByliss PRO',
    page: {
      path: '/brands/babyliss-pro',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Balance Me',
    page: {
      path: '/brands/balance-me',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'bareMinerals',
    page: {
      path: '/brands/bareminerals',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Baxter of California',
    page: {
      path: '/brands/baxter-of-california',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Bellapierre Cosmetics',
    page: {
      path: '/brands/bellapierre-cosmetics',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Bioderma',
    page: {
      path: '/brands/bioderma',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'BioSilk',
    page: {
      path: '/brands/biosilk',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Bloom and Blossom',
    page: {
      path: '/brands/bloom-and-blossom',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Love Boo',
    page: {
      path: '/brands/love-boo',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Braun',
    page: {
      path: '/brands/braun',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Bulldog Skincare For Men',
    page: {
      path: '/brands/bulldog-natural-grooming',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Bumble and Bumble',
    page: {
      path: '/brands/bumble-and-bumble',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Burberry',
    page: {
      path: '/brands/burberry',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: "Burt's Bees",
    page: {
      path: '/brands/burt-s-bees',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Butter LONDON',
    page: {
      path: '/brands/butter-london',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Calvin Klein',
    page: {
      path: '/brands/calvin-klein',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Carolina Herrera',
    page: {
      path: '/brands/carolina-herrera',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Caudalie',
    page: {
      path: '/brands/caudalie',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Chloe',
    page: {
      path: '/brands/chloe',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Christophe Robin',
    page: {
      path: '/brands/christophe-robin',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Clinique',
    page: {
      path: '/brands/clinique',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Cloud Nine',
    page: {
      path: '/brands/cloud-nine',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Connock London',
    page: {
      path: '/brands/connock-london',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Corioliss',
    page: {
      path: '/brands/corioliss',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Cowshed',
    page: {
      path: '/brands/cowshed',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Crystal Clear',
    page: {
      path: '/brands/crystal-clear',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Daniel Sandler',
    page: {
      path: '/brands/daniel-sandler',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Darphin',
    page: {
      path: '/brands/darphin',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Dead Sea Spa Magik',
    page: {
      path: '/brands/dead-sea-spa-magik',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Decléor',
    page: {
      path: '/brands/decleor',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Dermalogica',
    page: {
      path: '/brands/dermalogica',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Diesel',
    page: {
      path: '/brands/diesel',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Voir tout DKNY',
    page: {
      path: '/brands/dkny',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Dr. Brandt',
    page: {
      path: '/brands/dr-brandt',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Dr. Hauschka',
    page: {
      path: '/brands/dr-hauschka',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Dr. Lipp',
    page: {
      path: '/brands/dr-lipp',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'DS Laboratories',
    page: {
      path: '/brands/ds-laboratories',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'DuWop',
    page: {
      path: '/brands/duwop',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Elegant Touch',
    page: {
      path: '/brands/elegant-touch',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Elemental Herbology',
    page: {
      path: '/brands/elemental-herbology',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Elemis',
    page: {
      path: '/brands/elemis',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Elemis Men',
    page: {
      path: '/brands/elemis-men',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Elizabeth Arden',
    page: {
      path: '/brands/elizabeth-arden',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Essie',
    page: {
      path: '/brands/essie',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Estee Lauder',
    page: {
      path: '/brands/estee-lauder',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'EX1 Cosmetics',
    page: {
      path: '/brands/ex1-cosmetics',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Eylure',
    page: {
      path: '/brands/eylure',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Fake Bake',
    page: {
      path: '/brands/fake-bake',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Fudge',
    page: {
      path: '/brands/fudge',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Garnier',
    page: {
      path: '/brands/garnier',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Gatineau',
    page: {
      path: '/brands/gatineau',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: "Gentlemen's Tonic",
    page: {
      path: '/brands/gentleman-s-tonic',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Geo F Trumper',
    page: {
      path: '/brands/geo-f-trumper',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'GHD',
    page: {
      path: '/brands/ghd',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'GLAMGLOW',
    page: {
      path: '/brands/glamglow',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Goldwell',
    page: {
      path: '/brands/goldwell',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Green People',
    page: {
      path: '/brands/green-people',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Head Jog',
    page: {
      path: '/brands/head-jog',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Heal Gel',
    page: {
      path: '/brands/heal-gel',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'HoMedics',
    page: {
      path: '/brands/homedics',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Institut Esthederm',
    page: {
      path: '/brands/institut-esthederm',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Japonesque',
    page: {
      path: '/brands/japonesque',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'JASON',
    page: {
      path: '/brands/jason',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Jessica Nails',
    page: {
      path: '/brands/jessica-nails',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'John Masters Organics',
    page: {
      path: '/brands/john-masters-organics',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Joico',
    page: {
      path: '/brands/joico',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Joop',
    page: {
      path: '/brands/joop',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Juicy Couture',
    page: {
      path: '/brands/juicy-couture',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Jurlique',
    page: {
      path: '/brands/jurlique',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'KeraCare',
    page: {
      path: '/brands/keracare',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Kérastase',
    page: {
      path: '/brands/kerastase',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Kérastase Homme',
    page: {
      path: '/brands/kerastase-homme',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'KMS California',
    page: {
      path: '/brands/kms-california',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Korres',
    page: {
      path: '/brands/korres',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Lab Series Skincare for Men',
    page: {
      path: '/brands/lab-series-skincare-for-men',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Label.m',
    page: {
      path: '/brands/label-m',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Lancôme',
    page: {
      path: '/brands/lancome',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: "L'Anza",
    page: {
      path: '/brands/l-anza',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Leighton Denny',
    page: {
      path: '/brands/leighton-denny',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'LIERAC',
    page: {
      path: '/brands/lierac',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Lipstick Queen',
    page: {
      path: '/brands/lipstick-queen',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Living Nature',
    page: {
      path: '/brands/living-nature',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Lock Stock & Barrel',
    page: {
      path: '/brands/lock-stock-barrel',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Lord & Berry',
    page: {
      path: '/brands/lord-berry',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: "L'Oréal Men Expert",
    page: {
      path: '/brands/l-oreal-men-expert',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: "L'Oréal Paris",
    page: {
      path: '/brands/l-oreal-paris',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: "L'Oréal Professionnel",
    page: {
      path: '/brands/l-oreal-professionnel',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: "L'Oréal Professionnel Homme",
    page: {
      path: '/brands/l-oreal-professionel-homme',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'MAC Cosmetics',
    page: {
      path: '/brands/mac',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Mama Mio',
    page: {
      path: '/brands/mama-mio',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Matrix',
    page: {
      path: '/brands/matrix',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Maybelline',
    page: {
      path: '/brands/maybelline',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Menaji',
    page: {
      path: '/brands/menaji',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'MenScience',
    page: {
      path: '/brands/menscience',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Men-u',
    page: {
      path: '/brands/men-u',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Micro-Pedi',
    page: {
      path: '/brands/micro-pedi',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Molton Brown',
    page: {
      path: '/brands/molton-brown',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'MONU Professional Skincare',
    page: {
      path: '/brands/monu-skincare',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'MOR',
    page: {
      path: '/brands/mor',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Moschino',
    page: {
      path: '/brands/moschino',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Mr&Mrs Fragrance',
    page: {
      path: '/brands/mr-mrs-fragrance',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Murad',
    page: {
      path: '/brands/murad',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Myprotein',
    page: {
      path: '/brands/myprotein',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'MyVitamins',
    page: {
      path: '/brands/myvitamins',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Nails Inc.',
    page: {
      path: '/brands/nails-inc',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Nanogen',
    page: {
      path: '/brands/nanogen',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Natio',
    page: {
      path: '/brands/natio',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Natural Sea Sponge Co & Hydrea',
    page: {
      path: '/brands/natural-sea-sponge-co-hydrea',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Nina Ricci',
    page: {
      path: '/brands/nina-ricci',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'NIOXIN',
    page: {
      path: '/brands/nioxin',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'NIP + FAB',
    page: {
      path: '/brands/nip-fab',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Nourkrin',
    page: {
      path: '/brands/nourkrin',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'NuBo',
    page: {
      path: '/brands/nubo',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'NYX Professional Makeup',
    page: {
      path: '/brands/nyx-professional-makeup',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Omorovicza',
    page: {
      path: '/brands/omorovicza',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'OPI Nailcare',
    page: {
      path: '/brands/opi-nailcare',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Oral B',
    page: {
      path: '/brands/oral-b',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'ORLY',
    page: {
      path: '/brands/orly',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Oskia',
    page: {
      path: '/brands/oskia',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Paco Rabanne',
    page: {
      path: '/brands/paco-rabanne',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Parlux',
    page: {
      path: '/brands/parlux',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'PAYOT',
    page: {
      path: '/brands/payot',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Percy & Reed',
    page: {
      path: '/brands/percy-reed',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'PERRICONE MD',
    page: {
      path: '/brands/perricone-md',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Peter Thomas Roth',
    page: {
      path: '/brands/peter-thomas-roth',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'PHILIP B',
    page: {
      path: '/brands/philip-b',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Philip Kingsley',
    page: {
      path: '/brands/philip-kingsley',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Phyto',
    page: {
      path: '/brands/phyto',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Voir tout Pixi',
    page: {
      path: '/brands/pixi',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'PUREOLOGY',
    page: {
      path: '/brands/pureology',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Ralph Lauren',
    page: {
      path: '/brands/ralph-lauren',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'RapidLash',
    page: {
      path: '/brands/rapidlash',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Real Techniques',
    page: {
      path: '/brands/real-techniques',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Recipe For Men',
    page: {
      path: '/brands/recipe-for-men',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Redken',
    page: {
      path: '/brands/redken',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Redken Brews',
    page: {
      path: '/brands/redken-brews',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'REN',
    page: {
      path: '/brands/ren',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Rimmel London',
    page: {
      path: '/brands/rimmel',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Rio',
    page: {
      path: '/brands/rio',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'RMK',
    page: {
      path: '/brands/rmk',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Rodial',
    page: {
      path: '/brands/rodial',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'SACHAJUAN',
    page: {
      path: '/brands/sachajuan',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Salvatore Ferragamo',
    page: {
      path: '/brands/salvatore-ferragamo',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Sarah Chapman',
    page: {
      path: '/brands/sarah-chapman',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Seascape',
    page: {
      path: '/brands/seascape',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Sebastian Professional',
    page: {
      path: '/brands/sebastian-professional',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Sexy Hair',
    page: {
      path: '/brands/sexy-hair',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Shaveworks',
    page: {
      path: '/brands/shaveworks',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Shiseido',
    page: {
      path: '/brands/shiseido',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Show Beauty',
    page: {
      path: '/brands/show-beauty',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'SHU UEMURA ART OF HAIR',
    page: {
      path: '/brands/shu-uemura-art-of-hair',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Skin Doctors',
    page: {
      path: '/brands/skin-doctors',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Slendertone',
    page: {
      path: '/brands/slendertone',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'smashbox',
    page: {
      path: '/brands/smashbox',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Revlon',
    page: {
      path: '/brands/revlon',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'StriVectin',
    page: {
      path: '/brands/strivectin',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Tangle Teezer',
    page: {
      path: '/brands/tangle-teezer',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Thalgo',
    page: {
      path: '/brands/thalgo',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'This Works',
    page: {
      path: '/brands/this-works',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Trilogy',
    page: {
      path: '/brands/trilogy',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Tweezerman',
    page: {
      path: '/brands/tweezerman',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Ultrasun',
    page: {
      path: '/brands/ultrasun',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Urban Decay',
    page: {
      path: '/brands/urban-decay',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Viviscal',
    page: {
      path: '/brands/viviscal',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'WAHL',
    page: {
      path: '/brands/wahl',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Weleda',
    page: {
      path: '/brands/weleda',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Wella Color Fresh',
    page: {
      path: '/brands/wella-color-fresh',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Wella Professionals Care & Style',
    page: {
      path: '/brands/wella-professionals-care-style',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Westlab',
    page: {
      path: '/brands/westlab',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'XEN-TAN',
    page: {
      path: '/brands/xen-tan',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Yves Saint Laurent',
    page: {
      path: '/brands/yves-saint-laurent',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'e-Shave',
    page: {
      path: '/brands/e-shave',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Vita Liberata',
    page: {
      path: '/brands/vita-liberata',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Men Rock',
    page: {
      path: '/brands/men-rock',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'FOREO',
    page: {
      path: '/brands/foreo',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Scaramouche and Fandango',
    page: {
      path: '/brands/scaramouche-and-fandango',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Murdock London',
    page: {
      path: '/brands/murdock-london',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'La Roche-Posay',
    page: {
      path: '/brands/la-roche-posay',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'EOS',
    page: {
      path: '/brands/eos',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Emma Hardie',
    page: {
      path: '/brands/emma-hardie',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Marc Jacobs',
    page: {
      path: '/brands/marc-jacobs',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Pai Skincare',
    page: {
      path: '/brands/pai',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Tom Ford',
    page: {
      path: '/brands/tom-ford',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Bourjois',
    page: {
      path: '/brands/bourjois',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Ciate London',
    page: {
      path: '/brands/ciate',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Ortigia',
    page: {
      path: '/brands/ortigia',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Amouage',
    page: {
      path: '/brands/amouage',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Skinny Tan',
    page: {
      path: '/brands/skinny-tan',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Deborah Lippmann',
    page: {
      path: '/brands/deborah-lippmann',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'PMD',
    page: {
      path: '/brands/pmd',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Bolin & Webb',
    page: {
      path: '/brands/bolin-webb',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Cosmetics 27',
    page: {
      path: '/brands/cosmetics-27',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Radical Skincare',
    page: {
      path: '/brands/radical',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Taylor of Old Bond Street ',
    page: {
      path: '/brands/taylors-of-old-bond-street',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Marvis',
    page: {
      path: '/brands/marvis',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Freezeframe',
    page: {
      path: '/brands/freezeframe',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Jo Hansford',
    page: {
      path: '/brands/jo-hansford',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'SkinCeuticals',
    page: {
      path: '/brands/skinceuticals',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Scott Barnes',
    page: {
      path: '/brands/scott-barnes',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Imedeen',
    page: {
      path: '/brands/imedeen',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Proraso',
    page: {
      path: '/brands/proraso',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Erno Laszlo',
    page: {
      path: '/brands/erno-laszlo',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Red Carpet Manicure',
    page: {
      path: '/brands/red-carpet-manicure',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Pupa',
    page: {
      path: '/brands/pupa',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'NUXE',
    page: {
      path: '/brands/nuxe',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'skinChemists',
    page: {
      path: '/brands/skinchemists',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Polaar ',
    page: {
      path: '/brands/polaar',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'The Konjac Sponge Co',
    page: {
      path: '/brands/the-konjac-sponge-co',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'ila-spa',
    page: {
      path: '/brands/ila-spa',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Antipodes',
    page: {
      path: '/brands/antipodes',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Tanworx',
    page: {
      path: '/brands/tanworx',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Hand Chemistry',
    page: {
      path: '/brands/hand-chemistry',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Regenerate',
    page: {
      path: '/brands/regenerate',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Beauty Box',
    page: {
      path: '/brands/beauty-box',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'ARK',
    page: {
      path: '/brands/ark',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'T3',
    page: {
      path: '/brands/t3',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Michael Kors',
    page: {
      path: '/brands/michael-kors',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Amazing Cosmetics',
    page: {
      path: '/brands/amazing-cosmetics',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'KeraStraight',
    page: {
      path: '/brands/kerastraight',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'TanOrganic',
    page: {
      path: '/brands/tanorganic',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Glo',
    page: {
      path: '/brands/glo',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Lilibeth of New York',
    page: {
      path: '/brands/lilibeth-of-new-york',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Grow Gorgeous',
    page: {
      path: '/brands/grow-gorgeous',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Tous les soins TIGI',
    page: {
      path: '/brands/tigi',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Kebelo',
    page: {
      path: '/brands/kebelo',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'HD Brows',
    page: {
      path: '/brands/hd-brows',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Hydrea London',
    page: {
      path: '/brands/hydrea-london',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Wet Brush',
    page: {
      path: '/brands/wet-brush',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Versace',
    page: {
      path: '/brands/versace',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Trussardi',
    page: {
      path: '/brands/trussardi',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Louise Galvin',
    page: {
      path: '/brands/louise-galvin',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'INIKA',
    page: {
      path: '/brands/inika',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'First Aid Beauty',
    page: {
      path: '/brands/first-aid-beauty',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Rubis',
    page: {
      path: '/brands/rubis',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Cult51',
    page: {
      path: '/brands/cult51',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Inhibitif',
    page: {
      path: '/brands/inhibitif',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'NUDESTIX',
    page: {
      path: '/brands/nudestix',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Deciem',
    page: {
      path: '/brands/deciem',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Själ',
    page: {
      path: '/brands/sjal',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Bakel',
    page: {
      path: '/brands/bakel',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'PÜR MINERALS',
    page: {
      path: '/brands/pur-minerals',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Eucerin',
    page: {
      path: '/brands/eucerin',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Vichy',
    page: {
      path: '/brands/vichy',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Roger & Gallet',
    page: {
      path: '/brands/roger-gallet',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Sigma Maquillage',
    page: {
      path: '/brands/sigma',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Zoeva',
    page: {
      path: '/brands/zoeva',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Neville',
    page: {
      path: '/brands/neville',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Bubble T',
    page: {
      path: '/brands/bubble-t',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Mio Skincare',
    page: {
      path: '/brands/mio-skincare',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Zelens',
    page: {
      path: '/brands/zelens',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Look Good Feel Better',
    page: {
      path: '/brands/look-good-feel-better',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Ellis Faas',
    page: {
      path: '/brands/ellis-faas',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Embryolisse',
    page: {
      path: '/brands/embryolisse',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Chantecaille',
    page: {
      path: '/brands/chantecaille',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Beauty Works',
    page: {
      path: '/brands/beauty-works',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'NIOD',
    page: {
      path: '/brands/niod',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Klorane',
    page: {
      path: '/brands/klorane',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Rene Furterer',
    page: {
      path: '/brands/rene-furterer',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'RENU',
    page: {
      path: '/brands/renu',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Babyliss',
    page: {
      path: '/brands/babyliss',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Lancer',
    page: {
      path: '/brands/lancer',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Magnitone London',
    page: {
      path: '/brands/magnitone-london',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'ARgENTUM Apothecary',
    page: {
      path: '/brands/argentum',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Vera Wang',
    page: {
      path: '/brands/vera-wang',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Voir tous les produits Davidoff',
    page: {
      path: '/brands/davidoff',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Roberto Cavalli',
    page: {
      path: '/brands/roberto-cavalli',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Jean Paul Gaultier',
    page: {
      path: '/brands/jean-paul-gaultier',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Armani Beauty',
    page: {
      path: '/brands/giorgio-armani',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Invisibobble',
    page: {
      path: '/brands/invisibobble',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Rituals',
    page: {
      path: '/brands/rituals',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Cacharel',
    page: {
      path: '/brands/cacharel',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Emporio Armani',
    page: {
      path: '/brands/emporio-armani',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Uppercut Deluxe',
    page: {
      path: '/brands/uppercut-deluxe',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Lottie London',
    page: {
      path: '/brands/lottie-london',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'NEOM',
    page: {
      path: '/brands/neom',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Billion Dollar Brows',
    page: {
      path: '/brands/billion-dollar-brows',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'IOMA',
    page: {
      path: '/brands/ioma',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Sally Hansen',
    page: {
      path: '/brands/sally-hansen',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Max Factor',
    page: {
      path: '/brands/max-factor',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'FACE Stockholm',
    page: {
      path: '/brands/face-stockholm',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Instant Effects',
    page: {
      path: '/brands/instant-effects',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Uriage',
    page: {
      path: '/brands/uriage',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'theBalm',
    page: {
      path: '/brands/thebalm',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Hylamide',
    page: {
      path: '/brands/hylamide',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Illamasqua',
    page: {
      path: '/brands/illamasqua',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Naobay',
    page: {
      path: '/brands/naobay',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Tria',
    page: {
      path: '/brands/tria',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Schwarzkopf',
    page: {
      path: '/brands/schwarzkopf',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Gallinee',
    page: {
      path: '/brands/gallinee',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Argan Liquid Gold',
    page: {
      path: '/brands/argan-liquid-gold',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Holistic Silk',
    page: {
      path: '/brands/holistic-silk',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Aurelia Probiotic Skincare',
    page: {
      path: '/brands/aurelia',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Skin Republic',
    page: {
      path: '/brands/skin-republic',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'By Terry',
    page: {
      path: '/brands/by-terry',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Laura Geller',
    page: {
      path: '/brands/laura-geller',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Olaplex',
    page: {
      path: '/brands/olaplex',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'White Hot',
    page: {
      path: '/brands/white-hot',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Ingenious Beauty',
    page: {
      path: '/brands/ingenious-beauty',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Manuka Doctor',
    page: {
      path: '/brands/manuka-doctor',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Bean Body',
    page: {
      path: '/brands/bean-body',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Pro Blo',
    page: {
      path: '/brands/pro-blo',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'MDMflow',
    page: {
      path: '/brands/mdmflow',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Shea Moisture',
    page: {
      path: '/brands/shea-moisture',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Triumph and Disaster',
    page: {
      path: '/brands/triumph-and-disaster',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Dr. Botanicals',
    page: {
      path: '/brands/dr-botanicals',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: "Mane 'n Tail",
    page: {
      path: '/brands/mane-n-tail',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'As I Am',
    page: {
      path: '/brands/as-i-am',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Color WOW',
    page: {
      path: '/brands/color-wow',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'AromaWorks',
    page: {
      path: '/brands/aromaworks',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'MADARA',
    page: {
      path: '/brands/madara',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Fade Out',
    page: {
      path: '/brands/fade-out',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Obsessive Compulsive Cosmetics',
    page: {
      path: '/brands/obsessive-compulsive-cosmetics',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'LiftLab',
    page: {
      path: '/brands/liftlab',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Contour Cosmetics',
    page: {
      path: '/brands/contour-cosmetics',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'System Professional',
    page: {
      path: '/brands/system-professional',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Giovanni',
    page: {
      path: '/brands/giovanni',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Starskin',
    page: {
      path: '/brands/starskin',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'NuFACE',
    page: {
      path: '/brands/nuface',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'RPR',
    page: {
      path: '/brands/rpr',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Baby Quasar',
    page: {
      path: '/brands/baby-quasar',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Yes To',
    page: {
      path: '/brands/yes-to',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Aquis',
    page: {
      path: '/brands/aquis',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Bouclème',
    page: {
      path: '/brands/boucleme',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'ikoo',
    page: {
      path: '/brands/ikoo',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Skin79',
    page: {
      path: '/brands/skin79',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Borghese',
    page: {
      path: '/brands/borghese',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Indeed Labs',
    page: {
      path: '/brands/indeed-labs',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Skin Authority',
    page: {
      path: '/brands/skin-authority',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Popband',
    page: {
      path: '/brands/popband',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Verso',
    page: {
      path: '/brands/verso',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Vincent Longo',
    page: {
      path: '/brands/vincent-longo',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'ModelCo',
    page: {
      path: '/brands/modelco',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Mellow',
    page: {
      path: '/brands/mellow',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'The Vintage Cosmetics Company',
    page: {
      path: '/brands/the-vintage-cosmetics-company',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Time Bomb',
    page: {
      path: '/brands/time-bomb',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Prai',
    page: {
      path: '/brands/prai',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'UTAN and Tone',
    page: {
      path: '/brands/utan-and-tone',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Filorga',
    page: {
      path: '/brands/filorga',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Sienna X',
    page: {
      path: '/brands/sienna-x',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'DHC',
    page: {
      path: '/brands/dhc',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'The Ordinary',
    page: {
      path: '/brands/the-ordinary',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'The Jojoba Company',
    page: {
      path: '/brands/the-jojoba-company',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Archipelago Botanicals',
    page: {
      path: '/brands/archipelago-botanicals',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Unwash',
    page: {
      path: '/brands/unwash',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Ouai',
    page: {
      path: '/brands/ouai',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'MAGICSTRIPES',
    page: {
      path: '/brands/magicstripes',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Biolage',
    page: {
      path: '/brands/biolage',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'KMS',
    page: {
      path: '/brands/kms',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Talika',
    page: {
      path: '/brands/talika',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Mauli',
    page: {
      path: '/brands/mauli',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Algenist',
    page: {
      path: '/brands/algenist',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Wilma Schumann',
    page: {
      path: '/brands/wilma-schumann',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Pestle & Mortar',
    page: {
      path: '/brands/pestle-mortar',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Brushworks',
    page: {
      path: '/brands/brushworks',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Real Chemistry',
    page: {
      path: '/brands/real-chemistry',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Sampar',
    page: {
      path: '/brands/sampar',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Nesti Dante',
    page: {
      path: '/brands/nesti-dante',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Glov',
    page: {
      path: '/brands/glov',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Hurraw!',
    page: {
      path: '/brands/hurraw',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Eve Rebirth',
    page: {
      path: '/brands/eve-rebirth',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Bobbi Brown',
    page: {
      path: '/brands/bobbi-brown',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Aveeno',
    page: {
      path: '/brands/aveeno',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Neutrogena',
    page: {
      path: '/brands/neutrogena',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Piz Buin',
    page: {
      path: '/brands/piz-buin',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Regaine',
    page: {
      path: '/brands/regaine',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Benton',
    page: {
      path: '/brands/benton',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Voir tout CosRX',
    page: {
      path: '/brands/cosrx',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Nourella',
    page: {
      path: '/brands/nourella',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Acorelle',
    page: {
      path: '/brands/acorelle',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Valmont',
    page: {
      path: '/brands/valmont',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Delilah',
    page: {
      path: '/brands/delilah',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Skimono',
    page: {
      path: '/brands/skimono',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Elvie',
    page: {
      path: '/brands/elvie',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Diego Dalla Palma',
    page: {
      path: '/brands/diego-dalla-palma',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'LDN : Skins',
    page: {
      path: '/brands/ldn-skins',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'KIKI Health',
    page: {
      path: '/brands/kiki-health',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'ESPA',
    page: {
      path: '/brands/espa',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Slip Silk',
    page: {
      path: '/brands/slip-silk',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'INC.redible',
    page: {
      path: '/brands/incredible',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Teeez',
    page: {
      path: '/brands/teeez',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Avant Skincare',
    page: {
      path: '/brands/avant-skincare',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Bondi Sands',
    page: {
      path: '/brands/bondi-sands',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Spotlight',
    page: {
      path: '/brands/spotlight',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Mine Tan',
    page: {
      path: '/brands/mine-tan',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Anne Semonin',
    page: {
      path: '/brands/anne-semonin',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Natura Bissé',
    page: {
      path: '/brands/natura-biss',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'BeGlow',
    page: {
      path: '/brands/beglow',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Eyeko',
    page: {
      path: '/brands/eyeko',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'living proof',
    page: {
      path: '/brands/living-proof',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'J.One',
    page: {
      path: '/brands/jone',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'G9SKIN',
    page: {
      path: '/brands/g9skin',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Pearl Drops',
    page: {
      path: '/brands/pearl-drops',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Holika Holika',
    page: {
      path: '/brands/holika-holika',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Seoulista',
    page: {
      path: '/brands/seoulista',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Cover FX',
    page: {
      path: '/brands/cover-fx',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'SILKE London',
    page: {
      path: '/brands/silke-london',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Lumene',
    page: {
      path: '/brands/lumene',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: '3INA Makeup',
    page: {
      path: '/brands/3ina-makeup',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'SVR',
    page: {
      path: '/brands/svr',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Sleek',
    page: {
      path: '/brands/sleek',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Lancaster',
    page: {
      path: '/brands/lancaster',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Philosophy',
    page: {
      path: '/brands/philosophy',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'BBB London',
    page: {
      path: '/brands/bbb-london',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'AHAVA',
    page: {
      path: '/brands/ahava',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'CeraVe',
    page: {
      path: '/brands/cerave',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Sanctuary Spa',
    page: {
      path: '/brands/sanctuary-spa',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Carita',
    page: {
      path: '/brands/carita',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Oh K!',
    page: {
      path: '/brands/oh-k',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'BLEACH LONDON',
    page: {
      path: '/brands/bleach-london',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Leegeehaam',
    page: {
      path: '/brands/leegeehaam',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Lime Crime',
    page: {
      path: '/brands/lime-crime',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Barry M Cosmetics',
    page: {
      path: '/brands/barry-m-cosmetics',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Panier des Sens',
    page: {
      path: '/brands/panier-des-sens',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Farmacy',
    page: {
      path: '/brands/farmacy',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'BARBER PRO',
    page: {
      path: '/brands/barber-pro',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Ameliorate',
    page: {
      path: '/brands/ameliorate',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Apivita',
    page: {
      path: '/brands/apivita',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Shangpree',
    page: {
      path: '/brands/shangpree',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'StylPro',
    page: {
      path: '/brands/stylpro',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'ECOOKING',
    page: {
      path: '/brands/ecooking',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Neostrata',
    page: {
      path: '/brands/neostrata',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Dear Klairs',
    page: {
      path: '/brands/dear-klairs',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Miu Miu',
    page: {
      path: '/brands/miu-miu',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Luxie',
    page: {
      path: '/brands/luxie',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Little Butterfly London',
    page: {
      path: '/brands/little-butterfly-london',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Goldfaden MD',
    page: {
      path: '/brands/goldfaden-md',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Missha',
    page: {
      path: '/brands/missha',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'MGC Derma',
    page: {
      path: '/brands/mgc-derma',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'TriPollar',
    page: {
      path: '/brands/tripollar',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Cantu',
    page: {
      path: '/brands/cantu',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Too Cool For School',
    page: {
      path: '/brands/too-cool-for-school',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Ouidad',
    page: {
      path: '/brands/ouidad',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'CND',
    page: {
      path: '/brands/cnd',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Medik8',
    page: {
      path: '/brands/medik8',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Natasha Denona',
    page: {
      path: '/brands/natasha-denona',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Farsali',
    page: {
      path: '/brands/farsali',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Camille Rose',
    page: {
      path: '/brands/camille-rose',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'inglot',
    page: {
      path: '/brands/inglot',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Iconic London',
    page: {
      path: '/brands/iconic-london',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Revolution Beauty',
    page: {
      path: '/brands/revolution-beauty',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Novex',
    page: {
      path: '/brands/novex',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Uoma',
    page: {
      path: '/brands/uoma',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Lilly Lashes',
    page: {
      path: '/brands/lilly-lashes',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Carriere Freres',
    page: {
      path: '/brands/carriere-freres',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Reduit',
    page: {
      path: '/brands/reduit',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'Kloris',
    page: {
      path: '/brands/kloris',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'ORS',
    page: {
      path: '/brands/ors',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
  {
    name: 'GLOSSYBOX Skincare',
    page: {
      path: '/brands/glossybox-skincare',
      __typename: 'Page',
    },
    __typename: 'Brand',
  },
]
